import axios from "axios";
// Relative, not the bare "constants" specifier: baseUrl resolution for that
// bare form collides with @types/node's ambient Node.js "constants" module
// under tsc (customers.service.js has the same latent issue, but plain .js
// files aren't semantically type-checked so it never surfaces there).
import { API_URL } from "../constants";
import { CustomerLedgerResponse, KnownLedgerKind } from "types/CustomerLedger";

export interface FetchLedgerParams {
  kind?: KnownLedgerKind | string;
  openOnly?: boolean;
  page?: number;
  pageSize?: number;
  /** Attaches each item's `document_lines` (pr7-contract.md §Frontend/1). */
  withLines?: boolean;
}

/**
 * `GET /:companyId/customers/:customerId/ledger` (pr3b-contract.md §4a).
 */
export const fetchLedger = (
  companyId: string,
  customerId: string,
  { kind, openOnly, page, pageSize, withLines }: FetchLedgerParams = {}
): Promise<CustomerLedgerResponse> => {
  const url = `${API_URL}/${companyId}/customers/${customerId}/ledger`;
  const params: Record<string, string> = {};
  if (kind) params.kind = kind;
  if (openOnly) params.openOnly = "true";
  if (page) params.page = String(page);
  if (pageSize) params.pageSize = String(pageSize);
  if (withLines) params.withLines = "1";
  return axios.get(url, { params }).then((response) => response.data);
};
